import { api } from "./api";

// When the owner flips "Go Live", canonical URLs & OG images use the production domain.
export async function loadSiteOrigin() {
  try {
    const r = await api.get("/settings");
    if (r.data?.go_live && r.data?.production_url) {
      window.__SITE_ORIGIN__ = r.data.production_url.replace(/\/$/, "");
    }
  } catch {
    /* ignore — fall back to window origin */
  }
}

export function siteOrigin() {
  return window.__SITE_ORIGIN__ || window.location.origin;
}
